// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputBox_inputContainer__owtVf","input":"InputBox_input__2mmb4","sendButton":"InputBox_sendButton__uFkY7"};